import { createContext, useContext } from 'react';

import type { BrowserPhone } from './useBrowserPhone';

export type PhoneContextValue = BrowserPhone & { browserMode: boolean };

const noop = () => undefined;

// Ohne Browser-Telefonie (z. B. Außendienst, Tests ohne Provider): ausgeschaltetes Telefon.
const offPhone: PhoneContextValue = {
  state: 'off',
  error: undefined,
  muted: false,
  incoming: undefined,
  browserMode: false,
  expect: noop,
  cancelExpect: noop,
  accept: () => undefined,
  reject: noop,
  hangup: noop,
  toggleMute: noop,
};

export const PhoneContext = createContext<PhoneContextValue>(offPhone);

export function usePhone(): PhoneContextValue {
  return useContext(PhoneContext);
}
